import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { GenericSearchFilter } from '../api/use-generic-search-with-filter'
import type { LynkSearchFilter } from '../api/use-lynk-search-with-filter'
import type { SearchHistoryFilter } from '../api/use-search-history'

export const search = createQueryKeys('search', {
  generic: (query?: string, limit?: number) => [{ query, limit }],
  genericWithFilter: (filter?: GenericSearchFilter, query?: string, limit?: number, skip?: number) => [
    { filter, query, limit, skip },
  ],
  history: (filter: SearchHistoryFilter, limit?: number, skip?: number) => [{ filter, limit, skip }],
  deleteHistory: null,
  lynk: (query: string) => [{ query }],
  lynkWithFilter: (filter?: LynkSearchFilter, query?: string, limit?: number, skip?: number) => [
    { filter, query, limit, skip },
  ],
})
